export default "__VITE_ASSET__hrgjRa7s__"